const locationMap = (() => {
    const ResultsTypeClinician = "Clinician";
    const ResultsTypeLocation = "Location";
    const handleMapToggle = el => {
        el.querySelectorAll('[data-toggle-map-view]').forEach(toggle => {
            const listWrapper = el.querySelector('[data-results-list]');
            const mapWrapper = el.querySelector('[data-results-map]');
            toggle.addEventListener('click', () => {
                const text = toggle.querySelector('span[data-view-toggle-text]');
                const mapHideEls = el.querySelectorAll('[data-map-hide]');
                if (text.dataset.viewToggleText === 'Map ') {
                    listWrapper.classList.add('hidden');
                    mapWrapper.classList.remove('hidden');
                    if (text) {
                        text.dataset.viewToggleText = 'List ';
                    }
                    mapHideEls.forEach(mapHideEl => mapHideEl.classList.add('hidden'));
                    el.classList.add('map-view');
                    el.querySelectorAll('[data-icon-map]').forEach(mapIcon => mapIcon.classList.add('hidden'));
                    el.querySelectorAll('[data-icon-list]').forEach(listIcon => listIcon.classList.remove('hidden'));
                } else {
                    listWrapper.classList.remove('hidden');
                    mapWrapper.classList.add('hidden');
                    if (text) {
                        text.dataset.viewToggleText = 'Map ';
                    }
                    mapHideEls.forEach(mapHideEl => mapHideEl.classList.remove('hidden'));
                    el.classList.remove('map-view');
                    el.querySelectorAll('[data-icon-map]').forEach(mapIcon => mapIcon.classList.remove('hidden'));
                    el.querySelectorAll('[data-icon-list]').forEach(listIcon => listIcon.classList.add('hidden'));
                }
                window.scrollTo(0, 0);
            });
        });
    };
    
    const handleMapLoad = el => {
        const ids = el.querySelector('[data-map-ids]').dataset.mapIds;
        const mapWrapper = el.querySelector('[data-results-map]');
        if (mapWrapper) {
            fetch(`/Umbraco/management/api/Locations/GetLocations?ids=${ids}`)
                .then(response => response.json())
                .then(data => {
                    const mapContent = el.querySelector('[data-map-content]');
                    const mapNoResults = el.querySelector('[data-map-no-results]');
                    const totalResults = el.querySelector('[data-total-results]');
                    if (totalResults.dataset.totalResults !== "0 locations found") {
                        mapNoResults.classList.add('hidden');
                        mapContent.classList.remove('hidden');
                        let options = {
                            locations: data,
                            openWindow: false,
                            zoomControl: true,
                            fullscreenControl: true
                        };
                        new GoogleMap(mapContent, options);
                    } else {
                        mapNoResults.classList.remove('hidden');
                        mapContent.classList.add('hidden');
                    }
                });
        }
    };
    
    const handleViewOnMap = el => {
        el.querySelectorAll('[data-view-on-map]').forEach(result => {
            const id = result.dataset.viewOnMap;
            el.querySelectorAll('[data-toggle-map-view]').forEach(toggle => {
                const listWrapper = el.querySelector('[data-results-list]');
                const mapWrapper = el.querySelector('[data-results-map]');
                const text = toggle.querySelector('span[data-view-toggle-text]');
                const mapHideEls = el.querySelectorAll('[data-map-hide]');
                result.addEventListener('click', () => {
                    listWrapper.classList.add('hidden');
                    mapWrapper.classList.remove('hidden');
                    text.dataset.viewToggleText = 'List ';
                    mapHideEls.forEach(mapHideEl => mapHideEl.classList.add('hidden'));
                    mapWrapper.innerHTML = '';
                    fetch(`/Umbraco/management/api/Locations/GetLocations?ids=${id}`)
                        .then(response => response.json())
                        .then(data => {
                            let options = {
                                locations: data,
                                openWindow: false,
                                zoomControl: true,
                                fullscreenControl: true
                            };
                            new GoogleMap(mapWrapper, options);
                        });
                });
            });
        });
    };
    
    const getResultsType = scope => {
        return "Location";
    };

    const getCurrentSession = scope => {
        const model = {};
            model.sort = scope.querySelector('input[name="SortValue"]').value;
            
            const typeField = scope.querySelector('input[name="type"]:checked');
            const getCategory = scope.querySelector('input[name="category"]:checked');
            const serviceTypeField = scope.querySelector('input[name="ServiceType"]');

            if (typeField) {
                model.type = typeField.value;
            }

            if (serviceTypeField) {
                model.serviceType = serviceTypeField.value;
            }

            if (getCategory) {
                model.category = getCategory.value;
            } else {
                const params = new Proxy(new URLSearchParams(window.location.search), {
                    get: (searchParams, prop) => searchParams.get(prop),
                });

                if (params.category) {
                    model.category = params.category;
                }
            }
        

        const currentPageEl = scope.querySelector('[data-current-page]');
        const locationTypeField = scope.querySelector('input[name="locationRadios"]:checked');
        const locationInputField = scope.querySelector('input[name="townPostcode"]');
        const locationDistanceField = scope.querySelector('select[name="Distance"]');

        if (locationTypeField) {
            model.locationType = locationTypeField.value;
        }

        if (locationInputField && model.locationType !== "any") {
            model.locationInput = locationInputField.value;
        }

        if (locationDistanceField && model.locationType === "postcode") {
            model.locationDistance = locationDistanceField.value;
        }

        model.currentPage = parseInt(currentPageEl ? currentPageEl.dataset.currentPage : "1") || 1;
        model.nodeId = scope.querySelector('[data-node-id]').dataset.nodeId;

        return model;
    }

    const rememberedLocationCategories = {
        type: undefined,
        category: undefined
    };
    
    const bindLocationResults = (scope) => {
        const session = getCurrentSession(scope);

        handleMapLoad(scope);
        handleViewOnMap(scope);

        const wrapper = scope.querySelector('[data-categories-filter]');

        if (!wrapper) {
            return;
        }

        if (rememberedLocationCategories.type === session.type && rememberedLocationCategories.category === session.category) {
            return;
        }

        rememberedLocationCategories.type = session.type;
        rememberedLocationCategories.category = session.category;

        if (session.type === "any") {
            wrapper.outerHTML = '<div data-categories-filter></div>';
            return;
        }

        return fetch(`/umbraco/surface/LocationResults/GetCategories?type=${session.type}&selected=${session.category}`)
            .then(response => response.text())
            .then(data => {
                if (data !== '') {
                    wrapper.outerHTML = data;
                    const updatedWrapper = scope.querySelector('[data-categories-filter]');
                    const updatedCategories = updatedWrapper.querySelectorAll('input[type="radio"]').length;
                    if (updatedCategories > 2) {
                        updatedWrapper.querySelectorAll('input[type="radio"]').forEach(radio => {
                            radio.addEventListener('input', () => handleFilters(scope, 1));
                        });

                        const content = updatedWrapper.querySelector('[data-filter-group-content]');
                        updatedWrapper.querySelectorAll('[data-filter-group-toggle]').forEach(filterGroup => {
                            filterGroup.addEventListener('click', () => {
                                updatedWrapper.classList.toggle('filter-group--closed');
                                content.classList.toggle('filter-group__wrapper--open');
                            });
                        });
                        const selected = updatedWrapper.querySelector('[data-filter-selected]');
                        const selectedChecked = updatedWrapper.querySelector('input[type="radio"]:checked');
                        if (selectedChecked) {
                            const selectedRadio = selectedChecked.parentNode;
                            selected.innerHTML = selectedRadio.dataset.radio;
                        } else {
                            updatedWrapper.querySelector('input[type="radio"]').checked = true;
                            selected.innerHTML = 'Any';
                        }
                    } else {
                        updatedWrapper.outerHTML = '<div data-categories-filter></div>';
                    }
                } else {
                    wrapper.outerHTML = '<div data-categories-filter></div>';
                }
            });
    };
    
    const bindResults = scope => {
        const resultsType = getResultsType(scope);
        const totalResults = scope.querySelector('[data-total-results]');
        const results = scope.querySelector('[data-results]');

        if (totalResults && parseInt(totalResults.dataset.totalResultsCount) > 0) {
            results.classList.remove('search-results-block__results__wrapper--no-results');
        }
        else {
            results.classList.add('search-results-block__results__wrapper--no-results')
        }
        
        return bindLocationResults(scope);
        
    };
    
    const initBlock = scope => {
        bindResults(scope);
        if (scope.querySelector('[data-results-map]')) {
            handleMapToggle(scope);
        }
    };
    
    return {
        initBlock
    }
})();
ControlBinders.register(`[data-map-results]`, el => locationMap.initBlock(el));